<template>
  <v-card class="del-all-card">
    <!-- Ícono -->
    <div class="del-all-icon-wrap">
      <div class="del-all-icon-circle">
        <v-icon class="del-all-icon">delete_sweep</v-icon>
      </div>
    </div>

    <!-- Texto -->
    <div class="del-all-body">
      <h2 class="del-all-title">Eliminar Productos</h2>
      <p class="del-all-subtitle">
        Se eliminarán todos los productos del laboratorio seleccionado. Esta
        acción no se puede deshacer.
      </p>
    </div>

    <!-- Selector de laboratorio -->
    <div class="del-all-form">
      <v-select
        :error-messages="errors.collect('laboratory')"
        :items="laboratories"
        data-vv-name="laboratory"
        label="Laboratorio"
        no-data-text="Datos no disponibles"
        required
        hide-details
        v-model="form.labID"
        v-validate="'required'"
      ></v-select>
    </div>

    <!-- Botones -->
    <div class="del-all-actions">
      <button class="del-all-btn del-all-btn--cancel" @click="$emit('close')">
        Cancelar
      </button>
      <button
        class="del-all-btn del-all-btn--confirm"
        @click="deleteAll"
        :disabled="loading"
      >
        <span v-if="loading" class="del-all-spinner"></span>
        <span v-else>Eliminar</span>
      </button>
    </div>
  </v-card>
</template>

<script>
export default {
  data: () => ({
    laboratories: [],
    loading: false,
    form: {
      labID: '',
    },
  }),
  created() {
    this.$store.dispatch('laboratories/getAll', {}).then(response => {
      const data = response.items
      for (let index = 0; index < data.length; index += 1) {
        this.laboratories.push({
          text: data[index].name,
          value: data[index].id,
        })
      }
    })
  },
  methods: {
    deleteAll() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.loading = true
          this.$emit('loading-show')
          this.$store
            .dispatch('products/deleteAll', this.form)
            .then(response => {
              this.loading = false
              this.$emit('close')
              this.$emit('delete-ready', response.data.status)
            })
            .catch(() => {
              this.loading = false
            })
        }
      })
    },
  },
}
</script>

<style scoped>
.del-all-card {
  border-radius: 16px !important;
  overflow: hidden;
  padding: 0;
}

.del-all-icon-wrap {
  display: flex;
  justify-content: center;
  padding: 28px 24px 0;
}

.del-all-icon-circle {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: #fef2f2;
  border: 5px solid #fee2e2;
  display: flex;
  align-items: center;
  justify-content: center;
}

.del-all-icon {
  color: #e5252a !important;
  font-size: 26px !important;
}

.del-all-body {
  padding: 16px 28px 4px;
  text-align: center;
}

.del-all-title {
  font-size: 17px;
  font-weight: 700;
  color: #0f172a;
  margin: 0 0 6px;
  letter-spacing: -0.01em;
}

.del-all-subtitle {
  font-size: 13px;
  color: #64748b;
  line-height: 1.6;
  margin: 0;
}

.del-all-form {
  padding: 16px 28px 4px;
}

.del-all-actions {
  padding: 16px 28px 24px;
  display: flex;
  justify-content: center;
  gap: 10px;
}

.del-all-btn {
  height: 42px;
  padding: 0 24px;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
  border: none;
  cursor: pointer;
  transition: all 0.18s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 110px;
}

.del-all-btn:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}

.del-all-btn--cancel {
  background: #f1f5f9;
  color: #475569;
  border: 1px solid #e2e8f0;
}

.del-all-btn--cancel:hover:not(:disabled) {
  background: #e2e8f0;
}

.del-all-btn--confirm {
  background: #e5252a;
  color: #ffffff;
  box-shadow: 0 2px 8px rgba(229, 37, 42, 0.25);
}

.del-all-btn--confirm:hover:not(:disabled) {
  background: #c91e23;
}

.del-all-spinner {
  width: 16px;
  height: 16px;
  border: 2px solid rgba(255, 255, 255, 0.4);
  border-top-color: #ffffff;
  border-radius: 50%;
  animation: spin 0.7s linear infinite;
  display: inline-block;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
